import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!template-lint-disable no-yield-only}}\r\n{{yield}}",{ moduleName: "adcdriver/components/blank-template.hbs" })